import { render, staticRenderFns } from "./ContattiAby.vue?vue&type=template&id=6108ac39&"
import script from "./ContattiAby.vue?vue&type=script&lang=js&"
export * from "./ContattiAby.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports